// generated by the plop

import { Injectable } from '@angular/core';
import { Selector, State } from '@ngxs/store';
import { AccessState, AccessStateModel, ProfileState, ProfileStateModel, UserModel } from 'shared';
import { PermissionEnum } from 'symbols';
import { CLIENT_ACCESS_DEFAULT, ClientAccessModel } from './client-access.model';

@State({ name: 'ClientsAccess' })
@Injectable()
export class ClientAccessState {

  /**
   * Generate configs for classroom module depends on a provided user role.
   */
  static generateClientsAccess(roles: PermissionEnum[], user: UserModel): ClientAccessModel {
    // Return permissions as for an unknown role if user not verified or not authenticated.
    if (!user) {
      return this.generateRoleConfig(PermissionEnum.UNKNOWN);
    }

    // Apply permissions of each provided role.
    const rolesConfig: ClientAccessModel[] = roles.map(role => this.generateRoleConfig(role));

    // Return defined config.
    return this.mergeConfig(rolesConfig);
  }

  /**
   * Define and create config using provided config data.
   */
  static generateRoleConfig(role: PermissionEnum): ClientAccessModel {
    switch (role) {
      case PermissionEnum.CAN_READ_CLIENTS:
        return {
          ...CLIENT_ACCESS_DEFAULT,
          canReadClientStory: true
        };
      case PermissionEnum.CAN_READ_DEBTS:
        return {
          ...CLIENT_ACCESS_DEFAULT,
          canReadDebts: true
        };
      case PermissionEnum.SUPER_USER:
        return {
          canReadClientStory: true,
          canReadDebts: true
        };
      default: {
        return {
          ...CLIENT_ACCESS_DEFAULT
        };
      }
    }
  }

  /**
   * Merge provided roles configs (by union rule).
   */
  static mergeConfig(rolesConfig: ClientAccessModel[]): ClientAccessModel {
    const moduleConfig: ClientAccessModel = CLIENT_ACCESS_DEFAULT;

    for (const config of rolesConfig) {
      moduleConfig.canReadClientStory = moduleConfig.canReadClientStory ? true : config.canReadClientStory;
      moduleConfig.canReadDebts = moduleConfig.canReadDebts ? true : config.canReadDebts;
    }

    return moduleConfig;
  }

  /**
   * Define and create module access rules using provided portal data.
   */
  @Selector([ProfileState, AccessState])
  static accessToClients(profileState: ProfileStateModel, accessState: AccessStateModel): ClientAccessModel {
    const userData = profileState.currentUser;
    const roleList = accessState.roles;

    return ClientAccessState.generateClientsAccess(roleList, userData);
  }

}


